import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import theme from './theme';
import type { Theme } from './theme';

type ThemeProviderProps = React.PropsWithChildren<Record<string, unknown>>;

// TODO This should come from the redux store
const currentTheme: Theme = 'light';

export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <StyledThemeProvider theme={theme[currentTheme]}>
    {children}
  </StyledThemeProvider>
);
